'use client';

import { useRouter } from 'next/navigation';

import {
  notFoundDescription,
  notFoundGoBack,
  notFoundGoHome,
  notFoundShortTitle,
  notFoundTitle,
} from '@bells/i18n';
import { Button } from '@bells/ui/components/button';

export default function NotFoundComponent() {
  const router = useRouter();

  return (
    <>
      <div className='my-16 w-full items-center justify-center text-center'>
        <span className='bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent'>
          {notFoundTitle()}
        </span>
        <h2 className='font-heading my-2 text-2xl font-bold'>
          {notFoundShortTitle()}
        </h2>
        <p>{notFoundDescription()}</p>
        <div className='mt-8 flex justify-center gap-2'>
          <Button onClick={() => router.back()} variant='default' size='lg'>
            {notFoundGoBack()}
          </Button>
          <Button onClick={() => router.push('/')} variant='ghost' size='lg'>
            {notFoundGoHome()}
          </Button>
        </div>
      </div>
    </>
  );
}
